import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { API_URL } from "..";

const CityListLayer = ({ data = [], onAdd, onEdit, onRefresh }) => {
  const tableRef = useRef(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this city?")) return;

    const res = await fetch(`${API_URL}/api/city/${id}`, { method: "DELETE" });

    if (res.ok) onRefresh();
    else alert("Failed to delete");
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#cityTable")) {
      $("#cityTable").DataTable().destroy();
      $("#cityTable").empty();
    }

    if ($("#cityTable").length) {
      tableRef.current = $("#cityTable").DataTable({
        data: data || [],
        responsive: true,
        pageLength: 10,
        columns: [
          { data: "id", title: "ID", width: "80px" },
          { data: "name", title: "City Name" },
          {
            data: null,
            title: "Actions",
            orderable: false,
            width: "160px",
            render: (row) => `
              <div class="d-flex align-items-center gap-2" style="display: flex !important; flex-direction: row !important; align-items: center; gap: 8px;">
                <button type="button" class="btn btn-sm btn-primary edit-btn" data-id="${row.id}" data-name="${row.name}">
                  Edit
                </button>
                <button type="button" class="btn btn-sm btn-danger delete-btn" data-id="${row.id}">
                  Delete
                </button>
              </div>
            `,
          },
        ],
      });
    }

    $("#cityTable tbody").on("click", ".edit-btn", function () {
      onEdit({ id: $(this).data("id"), name: $(this).data("name") });
    });

    $("#cityTable tbody").on("click", ".delete-btn", function () {
      handleDelete($(this).data("id"));
    });

    return () => {
      $("#cityTable tbody").off("click");
      if ($.fn.DataTable.isDataTable("#cityTable")) {
        $("#cityTable").DataTable().destroy();
        $("#cityTable").empty();
      }
    };
  }, [data]);

  return (
    <div className="card basic-data-table">
      <style>
        {`
          #cityTable td:last-child {
            white-space: nowrap !important;
          }
          #cityTable .edit-btn,
          #cityTable .delete-btn {
            display: inline-flex !important;
            align-items: center;
            justify-content: center;
            padding: 5px 14px;
            font-size: 13px;
            border-radius: 6px;
          }
        `}
      </style>
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Cities</h5>
          <div className="col-md-6 text-end">
            <button className="btn btn-info" onClick={onAdd}>
              Add New City
            </button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="cityTable"></table>
      </div>
    </div>
  );
};

export default CityListLayer;
